import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
  hero_image:
    "https://images.unsplash.com/photo-1605918810583-f1626b5f6fd0?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=2000",
  hero_subtitle:
    "O mais alto fluxo de público em um endereço inteligente — lojas, gastronomia e negócios reunidos com praticidade que faz a diferença no seu dia.",
  positioning_paragraph:
    "Um conceito de street mall que une 35 lojas satélites e âncoras a 30 estandes inteligentes em contêineres, ancorados pela alta gastronomia do Kaven Restaurante e por um estacionamento farto. Tudo pensado para resolver o seu dia com fluidez.",
  container_text:
    "Espaços compactos de até 15m², altamente versáteis e econômicos. Perfeitos para pequenos salões, escritórios, lojas de roupas, charutarias, consultórios e prestadores de serviços. A solução ideal para abrir ou expandir sua empresa com baixo investimento inicial e um aluguel que realmente cabe no bolso.",
  parking_text:
    "O VM Piabetá conta com fácil rotativo nas ruas do entorno e 2 opções de estacionamentos pagos logo ao lado e em frente, garantindo total comodidade e segurança para você e seus clientes.",
  kaven_description:
    "O restaurante premium que ancora a experiência gastronômica do VM Piabetá — ambiente sofisticado para almoços de negócios e jantares memoráveis.",
};

const ContentContext = createContext(DEFAULTS);

export const useContent = () => useContext(ContentContext);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/content").then((res) => setContent({ ...DEFAULTS, ...res.data })).catch(() => {});
  }, []);
  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
}

export { DEFAULTS as CONTENT_DEFAULTS };
